import React from "react";
import { Card, Row } from "antd";
import { Chart, Axis, Geom, Tooltip, Legend } from "bizcharts";
import { inRange } from "lodash";
import DataSet from "@antv/data-set";
// Global Styles
import {
  CardTitleText,
  CardText,
} from "../../../../../../shared/globalStyling/styledText";

import { ExtraInfo } from "./";
import { formatWholeNumber } from "../../../../../../../core/utils/campaigns";

const VisitsByDayOfWeekCard = ({ data, counts, flightDates }) => {
  const ds = new DataSet().createView().source(data);
  ds.transform({
    type: "fold",
    fields: ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"],
    key: "dayOfWeek",
    value: "visits",
  });

  const getTickInterval = () => {
    let range = 0;
    let interval = 1;
    const max = counts.reduce((a, c) => {
      return Math.max(a, c);
    }, 0);
    while (!inRange(max, range, range + 10)) {
      range += 10;
      interval++;
    }
    while (interval % 5 !== 0) {
      range += 10;
      interval++;
    }
    return interval;
  };

  const scale = {
    visits: {
      tickInterval: getTickInterval(),
    },
  };

  const wholeDays = {
    Sun: "Sunday",
    Mon: "Monday",
    Tues: "Tuesday",
    Wed: "Wednesday",
    Thurs: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
  };

  const explanation =
    "This chart displays the number of first and returning visits to all targeted locations by weekday.";

  return (
    <Card
      title={<CardTitleText text={"Visits: By Day Of Week"} />}
      style={{
        height: "34.6em",
      }}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "2%",
      }}
      headStyle={{ borderWidth: "2px" }}
      bordered
      extra={<ExtraInfo placement={"topLeft"} title={explanation} />}
    >
      <Row type="flex" justify="center">
        <CardText
          text={`${flightDates.start} - ${flightDates.end} (+ 30 days)`}
        />
      </Row>
      <Chart
        padding={["auto", "auto", "auto", "auto"]}
        height={315}
        scale={scale}
        data={ds}
        forceFit
        onTooltipChange={ev => {
          let items = ev.items;
          const originFirst = items[0];
          const originReturn = items[1];
          items.splice(0);
          items.push({
            name: "First Visits",
            size: originFirst.size,
            showMarker: originFirst.showMarker,
            title: wholeDays[originFirst.title],
            marker: originFirst.marker,
            color: originFirst.color,
            value: formatWholeNumber(originFirst.value),
            x: originFirst.x,
            y: originFirst.y,
            point: originFirst.point,
          });
          if (originReturn) {
            items.push({
              name: "Returning Visits",
              size: originReturn.size,
              showMarker: originReturn.showMarker,
              title: wholeDays[originReturn.title],
              marker: originReturn.marker,
              color: originReturn.color,
              value: formatWholeNumber(originReturn.value),
              x: originReturn.x,
              y: originReturn.y,
              point: originReturn.point,
            });
          }
        }}
      >
        <Tooltip />
        <Legend position="top-center" marker="circle" />
        <Axis name="dayOfWeek" />
        <Axis
          name="visits"
          label={{
            formatter(text) {
              return formatWholeNumber(text);
            },
          }}
        />
        <Geom
          color={[
            "type",
            type => {
              if (type === "First Visits") return "#0077fe";
              else return "#ff0000";
            },
          ]}
          type="intervalStack"
          size={20}
          position="dayOfWeek*visits"
          style={{
            stroke: "#fff",
            lineWidth: 1,
          }}
        />
      </Chart>
    </Card>
  );
};

export default VisitsByDayOfWeekCard;
